var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateNewEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.472222,
    y: 0.472222,
    width: 13.0556,
    height: 13.0556,
    rx: 1.41667,
    fill: "#572148",
    stroke: "#572148",
    strokeWidth: 0.944444
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70036 3.40048C7.70036 3.26687 7.65071 3.13874 7.56234 3.04427C7.47396 2.9498 7.3541 2.89673 7.22911 2.89673C7.10413 2.89673 6.98427 2.9498 6.89589 3.04427C6.80752 3.13874 6.75787 3.26687 6.75787 3.40048V6.25505H4.08746C3.96248 6.25505 3.84261 6.30812 3.75424 6.40259C3.66586 6.49706 3.61621 6.6252 3.61621 6.7588C3.61621 6.8924 3.66586 7.02053 3.75424 7.115C3.84261 7.20947 3.96248 7.26255 4.08746 7.26255H6.75787V10.1171C6.75787 10.2507 6.80752 10.3789 6.89589 10.4733C6.98427 10.5678 7.10413 10.6209 7.22911 10.6209C7.3541 10.6209 7.47396 10.5678 7.56234 10.4733C7.65071 10.3789 7.70036 10.2507 7.70036 10.1171V7.26255H10.3708C10.4958 7.26255 10.6156 7.20947 10.704 7.115C10.7924 7.02053 10.842 6.8924 10.842 6.7588C10.842 6.6252 10.7924 6.49706 10.704 6.40259C10.6156 6.30812 10.4958 6.25505 10.3708 6.25505H7.70036V3.40048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewEvent);
export default __webpack_public_path__ + "static/media/CreateNewEvent.5d273447f3fc6f31a4e84fdd28b709ce.svg";
export { ForwardRef as ReactComponent };